import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css']
})
export class ButtonComponent implements OnInit {
  @Input() buttonText;
  @Output() clickAction = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  buttonClicked() {
    this.clickAction.emit();
  }

}
